var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n        stroke: currentColor;\n        stroke-width: .32px;\n      }\n\n      .st0, .st2 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st3 {\n        stroke-linecap: round;\n      }\n\n      .st1, .st3 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.55,5.87c0-.09,0-.19,0-.28,0-2.59-2.1-4.69-4.69-4.69S3.18,2.99,3.18,5.59c0,.09,0,.17,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.83,6.02c.02-.14.02-.29.02-.44,0-2.2-1.78-3.98-3.98-3.98s-3.98,1.78-3.98,3.98c0,.15,0,.3.03.45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 7.87,
    cy: 5.59,
    r: 1.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.87,
    y1: 2.09,
    x2: 7.87,
    y2: 3.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.87,
    y1: 7.25,
    x2: 7.87,
    y2: 8.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.37,
    y1: 5.59,
    x2: 6.21,
    y2: 5.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.53,
    y1: 5.59,
    x2: 11.37,
    y2: 5.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.39,
    y1: 3.11,
    x2: 6.69,
    y2: 4.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.04,
    y1: 6.76,
    x2: 9.84,
    y2: 7.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.9,
    y1: 7.55,
    x2: 6.69,
    y2: 6.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.04,
    y1: 4.41,
    x2: 10.34,
    y2: 3.11
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.29,10.5l.32-.72h-.37l.41-.69M5.19,10.74v-1.92c0-.11-.09-.19-.19-.19h-.15s-.02,0-.03,0c0,0,0-.03,0-.03v-.11c0-.06-.05-.11-.11-.11h-.4c-.06,0-.11.05-.11.11v.1s0,.02-.01.03-.04.01-.04.01h-.14c-.11,0-.19.09-.19.19v1.92c0,.11.09.19.19.19h1c.11,0,.19-.09.19-.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "3.39 10.23 1.72 10.23 1.72 6.83 .9 6.83 .9 10.93 3.39 10.93 3.39 10.23"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.17,11.64c.38-.45.59-.76.7-.96.11.2.32.51.7.96.39.46.5,1.03.29,1.48-.17.38-.54.6-.99.6h-.01c-.45,0-.82-.22-.99-.6-.21-.46-.1-1.03.3-1.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 7.87,
    cy: 12.39,
    r: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 9.52,
    y1: 10.74,
    x2: 6.21,
    y2: 14.04
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.92,
    cy: 9.37,
    r: 2.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 11.83,
    cy: 8.5,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.74,
    cy: 8.97,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.16,
    cy: 7.91,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14.02,
    cy: 8.64,
    r: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.19,10.04c.34,0,.26-.32.58-.32.35,0,.27.32.58.32s.24-.32.58-.32.29.32.58.32c.33,0,.21-.32.59-.32s.26.32.58.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.77,10.46c.35,0,.27.32.58.32s.24-.32.58-.32.29.32.58.32c.33,0,.21-.32.59-.32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialElements);
export default __webpack_public_path__ + "static/media/special-elements.c9aee713f48d732abe033caf5fafeab0.svg";
export { ForwardRef as ReactComponent };